import React from 'react';

const SelectionBox = ({ selectionBox }) => {
  if (!selectionBox) return null;

  return (
    <div
      className="flowchart__selection-box"
      style={{
        left: selectionBox.x,
        top: selectionBox.y,
        width: selectionBox.width,
        height: selectionBox.height,
      }}
    />
  );
};

export default SelectionBox;
